/* eslint-disable */
import React, { useState } from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import ReactPaginate from 'react-paginate';
import Modal from '../../ReusableTable/DssModel/DssModel';
import ColumnSelector from '../../ReusableTable/DssColumnSelectionModal/ColumnSelectionModal';
import './DynamicEditableTable.css';

const DynamicEditableTable = ({
  data,
  columns,
  onEdit,
  onDelete,
  openEditPopup,
  onPageChange,
  totalRecords,
  currentPage,
  itemsPerPage,
  handleDownload
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState(columns.map(col => col.accessor));

  const handlePageClick = ({ selected }) => {
    onPageChange(selected + 1);
  };

  const handleColumnChange = (newSelected) => {
    setSelectedColumns(newSelected);
    setIsModalOpen(false);
  };

  return (
    <><div className="table-container">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <p className="mb-0">Total Records: {totalRecords}</p>
      </div>

      <table className="table table-bordered" style={{ fontSize: "1px" }}>
        <thead className="table-light">
          <tr>
            {columns
              .filter(col => selectedColumns.includes(col.accessor))
              .map((col) => (
                <th key={col.accessor} style={{ whiteSpace: 'nowrap' }}>{col.header}</th>
              ))}
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((row, idx) => (
              <tr key={`${row.userName}-${idx}`}>
                {columns
                  .filter(col => selectedColumns.includes(col.accessor))
                  .map((col) => (
                    <td
                      key={col.accessor}
                      title={
                        ['created_on', 'updated_on'].includes(col.accessor)
                          ? row[col.accessor]
                            ? new Date(row[col.accessor]).toLocaleString('en-IN', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true,
                              })
                            : ''
                          : Array.isArray(row[col.accessor])
                          ? row[col.accessor].join(', ')
                          : row[col.accessor]
                      }
                      style={{
                        maxWidth: '180px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'fade',
                      }}
                    >
                      {col.accessor === 'is_active' ? (
                        <span className="badge" style={{ backgroundColor: row[col.accessor] ? '#04AA6D' : '#f44336' }}>
                          {row[col.accessor] ? 'Active' : 'Inactive'}
                        </span>
                      ) : ['created_on', 'updated_on'].includes(col.accessor) ? (
                        row[col.accessor]
                          ? new Date(row[col.accessor]).toLocaleString('en-IN', {
                              day: '2-digit',
                              month: 'short',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: true,
                            })
                          : ''
                      ) : (
                        Array.isArray(row[col.accessor])
                          ? row[col.accessor].join(', ')
                          : row[col.accessor]
                      )}
                    </td>

                  ))}
                <td>
                  {row.is_active ? (
                    <div className="d-inline-flex gap-2 align-items-center" style={{ paddingLeft: "20px", paddingRight: "20px" }}>
                      <i
                        style={{ cursor: "pointer", fontSize: "14px", paddingRight: "10px", color: "#4d4d4dff" }}
                        onClick={() => openEditPopup(row)}
                        title="Edit"
                      >
                        <FaEdit size={20} />
                      </i>
                      <i
                        style={{ cursor: "pointer", fontSize: "14px", color: "#f44336"  }}
                        onClick={() => onDelete(row)}
                        title="Delete"
                      >
                        <FaTrash size={20} />
                      </i>
                    </div>
                  ) : (
                    <span className="text-muted">No Actions</span>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={selectedColumns.length + 1} className="text-center">
                No data available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {/* Pagination */}
    </div>
    <div className="table-controls d-flex justify-content-between align-items-center">
        <button onClick={handleDownload} style={{ minWidth: "160px", background:"#04AA6D" }} className="download-button">DOWNLOAD</button>
        <button onClick={() => setIsModalOpen(true)} className="open-modal-button" style={{ minWidth: "160px" }}>CUSTOMIZE TABLE</button>
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <ColumnSelector
            columns={columns}
            selectedColumns={selectedColumns}
            onColumnChange={handleColumnChange} />
        </Modal>
        <div className="pagination-container">
          <ReactPaginate
            previousLabel="Previous"
            nextLabel="Next"
            breakLabel="..."
            pageCount={Math.ceil(totalRecords / itemsPerPage)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName="pagination"
            activeClassName="active"
          />
        </div>
      </div>
    </>
  );
};

export default DynamicEditableTable;
